export const environment = {
  production: true,
  version: '0.2.3',
  appName: 'Delher - Admin',
  branchName: 'Juventino Rosas',
  apiUrl: 'https://juv.api.delher.cloud',
  wsUrl: 'https://juv.api.delher.cloud',
  timezone: 'America/Mexico_City',
  locale: 'en',
  assets: {
    DEFAULT_USER_IMAGE: 'https://juv.api.delher.cloud/uploads/users/_DEFAULT.png',
    DEFAULT_VEHICLE_IMAGE: 'https://juv.api.delher.cloud/uploads/vehicles/_DEFAULT.png',
    DEFAULT_VEHICLE_TYPE_IMAGE: 'https://juv.api.delher.cloud/uploads/vehicles_types/_DEFAULT.png'
  }
};   
